(() => {
 function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const t = JSON.parse(root.querySelector('[data-box-text]').textContent);
  const form = root.querySelector('form');
  const sizes = [...root.querySelectorAll('[name="box_size"]')];
  const cards = [...root.querySelectorAll('[data-flavour-card]')];
  const inputs = cards.map(card => card.querySelector('[data-flavour-qty]'));
  const get = key => root.querySelector('[data-box-' + key + ']');
  const money = cents => new Intl.NumberFormat(root.dataset.locale || 'en-IN', {style:'currency',currency:root.dataset.currency || 'INR',maximumFractionDigits:2}).format(cents / 100);
  const sum = () => inputs.reduce((total, input) => total + (Number(input.value) || 0), 0);
  let busy = false;
  let failed = false;
  const selection = () => sizes.find(size => size.checked);
  function render() {
   const selected = selection();
   const capacity = Number(selected.value);
   const total = sum();
   const remaining = capacity - total;
   get('variant').value = selected.dataset.variant;
   const count = t.count.replace('{count}', total).replace('{size}', capacity);
   get('count').textContent = count;
   get('mobile-count').textContent = count;
   get('progress').max = capacity;
   get('progress').value = Math.min(total, capacity);
   get('instruction').textContent = remaining > 0 ? t.remaining.replace('{count}',remaining) : remaining < 0 ? t.over.replace('{count}',-remaining) : t.complete;
   get('instruction').classList.toggle('zbox-over', remaining < 0);
   get('price').textContent = selected.dataset.variant ? money(Number(selected.dataset.price)) : t.previewPrice;
   const mrp = Number(selected.dataset.mrp);
   const price = Number(selected.dataset.price);
   get('mrp').hidden = !(mrp > price);
   get('saving').hidden = !(mrp > price);
   get('mrp').textContent = t.mrp + ' ' + money(mrp);
   get('saving').textContent = t.save.replace('{percent}', Math.round((mrp - price) * 1000 / mrp)/10);
   get('list').replaceChildren();
   get('properties').replaceChildren();
   inputs.forEach((input, index) => {
    const qty = Number(input.value);
    const card = cards[index];
    const unavailable = input.disabled;
    card.classList.toggle('is-selected', qty > 0);
    card.querySelector('[data-step="-1"]').disabled = busy || unavailable || qty === 0;
    card.querySelector('[data-step="1"]').disabled = busy || unavailable || remaining <= 0;
    input.readOnly = busy;
    input.max = String(Math.max(qty, qty + remaining));
    if (qty > 0) {
     const li = document.createElement('li');
     const name = document.createElement('span');
     const value = document.createElement('strong');
     name.textContent = card.dataset.name;
     value.textContent = '× ' + qty;
     const thumbnail = document.createElement('img');
     thumbnail.src = card.querySelector('.zbox-photo img').src.replace('width=400','width=100');
     thumbnail.alt = '';
     thumbnail.width = 44;
     thumbnail.height = 60;
     thumbnail.loading = 'lazy';
     li.append(thumbnail, name, value);
     get('list').append(li);
     const prop = document.createElement('input');
     prop.type = 'hidden';
     prop.name = 'properties[' + card.dataset.name + ']';
     prop.value = String(qty);
     get('properties').append(prop);
    }
   });
   get('empty').hidden = total !== 0;
   sizes.forEach(size => size.disabled = busy);
   get('reset').disabled = busy;
   const valid = remaining === 0 && selected.dataset.available === 'true' && Boolean(selected.dataset.variant);
   get('submit').disabled = busy || !valid || failed;
   get('submit').textContent = busy ? t.adding : failed ? t.checkCart : !selected.dataset.variant ? t.previewButton : selected.dataset.available !== 'true' ? t.soldOut : remaining === 0 ? t.addBox : t.fillFirst;
  }
  cards.forEach((card, i) => {
   card.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
    if (busy || button.disabled) return;
    inputs[i].value = String(Math.max(0, Number(inputs[i].value) + Number(button.dataset.step)));
    render();
   }));
   inputs[i].addEventListener('input', () => {
    const max = Math.max(0,Number(selection().value) - inputs.reduce((total,input,j)=>total+(j===i?0:Number(input.value)||0),0));
    inputs[i].value = String(Math.min(max,Math.max(0,Math.floor(Number(inputs[i].value)||0))));
    render();
   });
  });
  sizes.forEach(size => size.addEventListener('change',render));
  get('reset').addEventListener('click', () => { inputs.forEach(input=>input.value='0'); render(); });
  get('jump').addEventListener('click', () => root.querySelector('.zbox-summary').scrollIntoView({behavior:'smooth',block:'center'}));
  form.addEventListener('submit', async event => {
   event.preventDefault();
   if (busy || failed || get('submit').disabled || sum() !== Number(selection().value)) return;
   busy = true;
   get('error').hidden = true;
   render();
   const properties = {'Box size': selection().value + ' bottles'};
   inputs.forEach((input,i) => {if(Number(input.value)>0) properties[cards[i].dataset.name]=String(input.value) + ' bottle' + (Number(input.value) === 1 ? '' : 's');});
   try {
    const response = await fetch(root.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:selection().dataset.variant,quantity:1,properties}]})});
    const result = await response.json();
    if (!response.ok) {
     get('error').textContent = typeof result.description === 'string' ? result.description : t.error;
     get('error').hidden = false;
     busy = false;
     render();
     return;
    }
    window.location.assign(root.dataset.cartUrl);
   } catch(error) {
    failed = true;
    busy = false;
    get('error').replaceChildren(document.createTextNode(t.network + ' '));
    const link = document.createElement('a');
    link.href = root.dataset.cartUrl;
    link.textContent = t.checkCart;
    get('error').append(link);
    get('error').hidden = false;
    render();
   }
  });
  render();
 }
 document.querySelectorAll('[data-box-builder]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-box-builder]').forEach(init));
})();


